import React from "react";
import { useSelector } from "react-redux";
import {
  getQuestionsAndAnswers,
  selectAppraisal
} from "../../../store/selectors";
import useModificationQuestionCompact from "../hooks/useModificationQuestionCompact";

interface IModificationQuestionCompactProps {
  question: Question;
  subtitle: string;
}

export const ModificationQuestionCompact = ({
  question,
  subtitle
}: IModificationQuestionCompactProps) => {
  const questionsAndAnswers = useSelector(getQuestionsAndAnswers);
  const storedAnswer = questionsAndAnswers && questionsAndAnswers[question.id];
  const { conditionalAnswersSubmitted } = useSelector(selectAppraisal);

  const {
    noDamage,
    handleChange,
    answer,
    groupName,
    questionString,
    noDamageLabel,
    showSelectLabel,
    showSelectValue,
    damageAnswer
  } = useModificationQuestionCompact({ question });
  const isAnswerSubmitted = conditionalAnswersSubmitted.includes(question.id);
  const radioError = !storedAnswer && isAnswerSubmitted;
  return (
    <>
      <hr className="ch-bg--grey-3 review-divider" />
      <div className="ch-pt--8 ch-pb--6">
        <h3 className="ch-text--normal">{subtitle}</h3>
        <p className="ch-width--12 ch-form__control-label ch-mb--2">
          {questionString}
        </p>

        <div className="ch-form__group">
          {radioError && (
            <div className="ch-form__group ch-form__group--error ch-mb--0">
              <span className="ch-form__control-validation ch-mb--1">
                Please choose an option
              </span>
            </div>
          )}
          <div>
            <input
              id={`${groupName}-yes`}
              type="radio"
              name={`${groupName}NeedRepaired`}
              value={damageAnswer}
              className="ch-radio"
              checked={
                (Boolean(answer) && answer[0] === showSelectValue) ||
                (Boolean(answer) &&
                  Boolean(noDamage) &&
                  answer[0] !== noDamage)
              }
              onChange={({ target: { value } }) => {
                handleChange(parseInt(value));
              }}
            />
            <label
              htmlFor={`${groupName}-yes`}
              className="ch-radio__label ch-radio__label--primary ch-mr--2 "
            >
              {showSelectLabel}
            </label>

            <input
              id={`${groupName}-no`}
              type="radio"
              name={`${groupName}NeedRepaired`}
              value={noDamage}
              className="ch-radio"
              checked={
                Boolean(answer) &&
                Boolean(noDamage) &&
                answer[0] === noDamage
              }
              onChange={({ target: { value } }) => {
                handleChange(parseInt(value));
              }}
            />
            <label
              htmlFor={`${groupName}-no`}
              className="ch-radio__label ch-radio__label--primary "
            >
              {noDamageLabel}
            </label>
          </div>
        </div>
      </div>
    </>
  );
};
